import React from 'react';
import {FormikProps} from 'formik';
import {EvaluationTask} from '@/views/admin/channel/types';

type Props = {
  formik: FormikProps<EvaluationTask>;
};

const EvaluationTaskChatFeaturesFormFields: React.FC<Props> = React.memo(({formik}) => (
    <></>
));

export default EvaluationTaskChatFeaturesFormFields; 